"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _core = require("@material-ui/core");

var _NavList = _interopRequireDefault(require("../NavList"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = {
  list: {
    overflow: 'hidden'
  }
};

var Nav = function Nav(_ref) {
  var routes = _ref.routes,
      setOpened = _ref.setOpened;
  var currentPath = (0, _reactRedux.useSelector)(function (state) {
    return state.router.location.pathname;
  });
  return _react.default.createElement(_core.List, {
    style: styles.list
  }, _react.default.createElement(_NavList.default, {
    currentPath: currentPath,
    routes: routes,
    onClick: function onClick() {
      return setOpened && setOpened(false);
    }
  }));
};

Nav.propTypes = {
  routes: _propTypes.default.array,
  setOpened: _propTypes.default.func.isRequired
};
var _default = Nav;
exports.default = _default;